import './InventoryEstimate.scss';
import Component from './InventoryEstimate.js';
export default Component;
